import React, { Component } from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function EvaSchiffererCoachingPage() {
  return <div className="min-h-screen bg-white" data-id="element-1232">
      <Header data-id="element-1233" />
      {/* Hero Section mit Bild und Überschrift */}
      <section className="w-full mt-[152px] flex justify-center" data-id="element-1234">
        <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1235">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9gw5kXj1skkX9MZLum1Qzd/Header-Lebenscoaching-Eva_Schifferer.jpg" alt="Coaching Header Bild" className="w-full h-full object-cover" data-id="element-1236" />
          <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1237"></div>
          <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-1238">
            <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-1239">
              <div className="max-w-lg text-left" data-id="element-1240">
                <p className="text-white text-2xl md:text-3xl font-light mb-4" data-id="element-1241">
                  Denn manchmal braucht es einen Wegbegleiter für den nächsten
                  Schritt
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="w-full py-16 px-6 md:px-12" data-id="element-1242">
        <div className="max-w-4xl mx-auto" data-id="element-1243">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1244">
            Coaching
          </h1>
          <div className="prose prose-lg max-w-none" data-id="element-1245">
            <div className="mb-8" data-id="element-1246">
              <p className="text-lg text-gray-700 mb-6" data-id="element-1247">
                Manche Lebensphasen laden dazu ein, innezuhalten, neue
                Perspektiven zu gewinnen – und bewusste Entscheidungen zu
                treffen. Ob innere Unruhe, berufliche Umbrüche oder der Wunsch
                nach persönlicher Klärung: Coaching schafft Raum für Reflexion,
                Entwicklung und echte Veränderung – individuell, konkret und
                wirksam.
              </p>
              <p className="text-lg text-gray-700" data-id="element-1248">
                Coaching stärkt Sie in Ihrer Wirksamkeit – in Ihrem beruflichen
                Umfeld ebenso wie im privaten Leben. Es richtet sich an
                Führungskräfte, Mitarbeitende und Einzelpersonen, die wachsen,
                gestalten und ihren Weg selbstbewusster gehen möchten. Im
                Mittelpunkt stehen Ihre Themen, Ihre Ziele und Ihre Ressourcen –
                ich unterstütze Sie mit langjähriger Coaching-Erfahrung sowie
                einem gut gefüllten Methodenkoffer dabei, konkrete Schritte zu
                entwickeln und in die Umsetzung zu bringen.
              </p>
            </div>
            <p className="text-lg text-gray-700 mb-8 font-medium" data-id="element-1249">
              Denn Standardlösungen bringen selten nachhaltige Veränderung.
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-1250">
              Ihre Lebensrealität – und Ihr berufliches Umfeld – ist zu komplex
              für pauschale Tools oder Tipps aus dem
              Selbstoptimierungsbaukasten.
            </p>
            <div className="flex flex-col md:flex-row gap-8 mb-12" data-id="element-1251">
              <div className="w-full md:w-1/2" data-id="element-1252">
                <p className="text-lg text-gray-700" data-id="element-1253">
                  <a href="https://www.wandelwert.com" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1254">
                    Mit über 15 Jahren Coaching Erfahrung
                  </a>{' '}
                  im Business Kontext biete ich professionelles Coaching – ohne
                  Esoterik und vermeintliche Patentlösungen. Wir erkennen
                  gemeinsam Muster, klären Ziele und schaffen neue
                  Handlungsspielräume – mit Tiefe, Struktur und einem klaren
                  Blick für das, was möglich ist.
                </p>
              </div>
              <div className="w-full md:w-1/2" data-id="element-1255">
                <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1256">
                  <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1257">
                    „Zwischen Reiz und Reaktion liegt ein Raum. In diesem Raum
                    liegt unsere Macht zur Wahl unserer Reaktion."
                  </blockquote>
                  <p className="text-right text-gray-600" data-id="element-1258">– Viktor E. Frankl</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg mb-12" data-id="element-1259">
              <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1260">
                Wie das funktioniert? Wir schauen gemeinsam hinter die Kulissen:
              </h2>
              <ul className="space-y-4 text-gray-700" data-id="element-1261">
                <li className="flex items-start" data-id="element-1262">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1263"></div>
                  <span data-id="element-1264">
                    Wir analysieren Denk- und Verhaltensmuster, die Sie (noch)
                    blockieren.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1265">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1266"></div>
                  <span data-id="element-1267">
                    Wir entwickeln klare, umsetzbare Schritte, die wirklich zu
                    Ihnen passen.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1268">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1269"></div>
                  <span data-id="element-1270">
                    Wir arbeiten an Gewohnheiten und Strukturen, nicht nur an
                    Symptomen.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1271">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1272"></div>
                  <span data-id="element-1273">
                    Und wir stellen sicher, dass die Veränderungen langfristig
                    wirksam sind.
                  </span>
                </li>
              </ul>
            </div>
            <div className="mb-12" data-id="element-1274">
              <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1275">
                Themen für ein Coaching können sein:
              </h2>
              <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-1276">
                <AccordionItem value="item-1" title="Orientierung in beruflichen oder privaten Umbruchphasen" data-id="element-1277">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1278">
                    Veränderungen kommen oft ungeplant – sei es durch
                    Jobwechsel, neue Lebenssituationen oder innere
                    Veränderungsimpulse. Im Coaching schaffen wir einen klaren
                    Rahmen, um Gedanken zu sortieren, Prioritäten
                    herauszuarbeiten und tragfähige Entscheidungen zu treffen.
                    So entsteht Klarheit über den nächsten Schritt.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-2" title="Der Wunsch nach persönlicher Weiterentwicklung und Klarheit bei Entscheidungen" data-id="element-1279">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1280">
                    Ob beruflich oder privat: Weiterentwicklung beginnt mit der
                    Frage, was Sie wirklich wollen. Coaching bietet Raum für
                    Reflexion, Standortbestimmung und die Gestaltung Ihrer
                    nächsten Schritte. Dabei richten wir den Blick hin zu dem,
                    was Ihnen wirklich wichtig ist und schärfen wir Ihren
                    inneren Kompass, damit Entscheidungen nicht nur vernünftig
                    klingen, sondern sich auch stimmig anfühlen.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-3" title="Krisen nach Trennung, Verlust oder Krankheit" data-id="element-1281">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1282">
                    Auch wenn Coaching keine Therapie ersetzt, kann es in
                    herausfordernden Lebensphasen wichtige Impulse geben. Wenn
                    vertraute Strukturen wegbrechen, geht es oft darum, sich neu
                    zu orientieren, Stabilität zu finden und den eigenen Weg
                    weiterzugehen – in Ihrem Tempo, mit professioneller
                    Begleitung.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-4" title="Selbstwertthemen und emotionale Erschöpfung" data-id="element-1283">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1284">
                    Wer dauerhaft funktionieren muss, verliert oft den Kontakt
                    zu sich selbst – zu den eigenen Bedürfnissen, Grenzen und
                    inneren Stärken. Gefühle von „nicht gut genug sein" oder
                    chronische Erschöpfung sind häufig Signale, dass es Zeit
                    ist, innezuhalten.
                  </p>
                  <p className="text-gray-600 leading-relaxed mt-4" data-id="element-1285">
                    Im Coaching stärken wir Ihre Selbstwahrnehmung, hinterfragen
                    einschränkende Überzeugungen und fördern Selbstfürsorge im
                    Alltag – damit wieder mehr Energie, Leichtigkeit und
                    Selbstvertrauen in Ihr Leben zurückkehren können.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-5" title="Die eigenen Stärken entdecken" data-id="element-1286">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1287">
                    Viele Menschen unterschätzen, was in ihnen steckt – oder
                    nehmen ihre Fähigkeiten als selbstverständlich hin. Im
                    Coaching richten wir den Blick gezielt auf Ihre Ressourcen,
                    Talente und Potenziale. Mit meiner Expertise im
                    Stärken-Coaching entsteht ein neues Selbstverständnis, das
                    stärkt, motivieren kann und Sie im Alltag wirkungsvoller
                    macht – für Ihre beruflichen wie privaten Herausforderungen.
                  </p>
                </AccordionItem>
              </Accordion.Root>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1288">
              <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1289">
                Coaching, das wirkt
              </h2>
              <p className="text-lg text-gray-700" data-id="element-1290">
                Coaching ist keine Therapie – aber es kann tiefgreifend
                verändern. Es geht nicht darum, besser zu „funktionieren",
                sondern echte Verbindung zu sich selbst zu entwickeln und daraus
                neue Kraft und Klarheit zu schöpfen.
              </p>
            </div>
            <div className="mt-8 text-center" data-id="element-1291">
              <p className="text-gray-600" data-id="element-1292">
                Weitere Informationen zum Ablauf und Honorar finden Sie{' '}
                <a href="/eva_schifferer/info" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1293">
                  hier
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
      <EvaSchiffererFooter data-id="element-1294" />
    </div>;
}
// Accordion Item Component
const AccordionItem = ({
  children,
  value,
  title
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-1295">
      <Accordion.Header data-id="element-1296">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-1297">
          <span className="text-lg font-medium text-gray-700" data-id="element-1298">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#c2cde0] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-1299" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-1300">
        <div className="p-4 bg-white" data-id="element-1301">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};